import { Box, Container, Grid, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import dotted from "../assets/bg-shape-points.png"
import {motion} from "framer-motion"

const Testimonials = () => {
  const testimonials = [
    {
      text: "लगातार उच्च गुणवत्ता और समय पर डिलीवरी। उनकी रेत और एग्रीगेट सप्लाई ने हमारे हाईवे प्रोजेक्ट को बिना किसी रुकावट के तय समय पर पूरा करने में मदद की।",
      name: "राकेश वर्मा",
      role: "प्रोजेक्ट मैनेजर, इन्फ्राबिल्ड इंडिया",
    },
    {
      text: "भरोसेमंद लॉजिस्टिक्स और उत्कृष्ट सामग्री गुणवत्ता। हमने कई आवासीय परियोजनाओं के लिए एग्रीगेट और ईंटों की सप्लाई इन्हीं से ली है।",
      name: "अमित शर्मा",
      role: "निदेशक, श्री कंस्ट्रक्शंस",
    },
    {
      text: "इनकी खनन और सप्लाई संचालन व्यवस्था सुव्यवस्थित और नियमों के अनुरूप है। बड़े स्तर की इंफ्रास्ट्रक्चर परियोजनाओं के लिए एक भरोसेमंद भागीदार।",
      name: "संजय सिंह",
      role: "साइट इंजीनियर, नेशनल हाईवे प्रोजेक्ट्स",
    },
    {
      text: "मजबूत संचालन क्षमता और पारदर्शी संवाद। उच्च मात्रा वाली निर्माण आवश्यकताओं के लिए आदर्श।",
      name: "नीरज गुप्ता",
      role: "प्रोक्योरमेंट मैनेजर, एपेक्स बिल्डटेक",
    }
  ];  

  return (
    <Box sx={{ background: "#1F0A00", color: "#fff", py: 10, position:"relative" }}>
        <Box
          className="dottedLayer"
          sx={{
            backgroundImage: `url(${dotted})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top right",
            backgroundSize: "contain",
            position: "absolute",
            width: "100%",
            height: "100%",
            opacity: 1,
            zIndex: 0,
            top: 0,
            left: 0,
            pointerEvents: "none",
          }}
        />
      <Container maxWidth="lg">
        {/* Top Title */}
        <Box textAlign="center" mb={4}>
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <Typography
            variant="subtitle2"
            className="paraAfter-line"
            sx={{ marginBottom: "20px" }}
          >
            TESTIMONIALS
          </Typography>

          <Typography
            variant="h1"
            className="headPara"
            sx={{
              fontWeight: 700,
              mb: 3,
              lineHeight: 1.2,
              color: "#fff",
            }}
          >
            Client Reviews
          </Typography>
          </motion.div>
        </Box>

        {/* Testimonial Slider */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
        <Swiper
          className="testi-slider"
          modules={[Pagination, Autoplay]}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3500 }}
          loop={true}
          style={{ paddingBottom: "120px" }} // space for dots
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <Grid container justifyContent="center">
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      background: "#2E0B00",
                      p: { xs: 4, md: 8 },
                      borderRadius: "10px",
                      position: "relative",
                    }}
                  >
                    {/* Quote Icon */}
                    <Box
                      sx={{
                        position: "absolute",
                        right: 25,
                        bottom: -40,
                        fontSize: "100px",
                        // opacity: 0.3,
                        color: "#fec810",
                      }}
                    >
                      ❞
                    </Box>

                    <Typography
                      sx={{
                        fontSize: "25px",
                        lineHeight: 1.6,
                        mb: 4,
                        opacity: 0.9,
                      }}
                    >
                      {item.text}
                    </Typography>

                    {/* Name + Role */}
                    <Typography sx={{ fontWeight: 600, fontSize: "20px" }}>
                      {item.name}
                    </Typography>
                    <Typography sx={{ opacity: 0.7 }}>{item.role}</Typography>
                  </Box>
                </Grid>
              </Grid>
            </SwiperSlide>
          ))}
        </Swiper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Testimonials;
